var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveFarmer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#101944"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_102",
    "data-name": "Mask Group 102",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "farmer_1_",
    "data-name": "farmer (1)",
    transform: "translate(5.985 4.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(3.96 14.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_125",
    "data-name": "Ellipse 125",
    cx: 0.264,
    cy: 0.264,
    r: 0.264,
    fill: "#101944"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 0.264,
    cy: 0.264,
    r: 0.264,
    transform: "translate(5.583)",
    fill: "#101944"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M16.165,12.182a3.085,3.085,0,0,0-1.644-1.129l-.515-.089a.5.5,0,0,0-.395-.356l-.726-.126a.5.5,0,0,0-.489.2l-.69-.117a.622.622,0,0,1-.087-.3V9.822a3.866,3.866,0,0,0,.446-.331A3.131,3.131,0,0,0,13.12,7.419a.824.824,0,0,0,.79-.822V6.286a.819.819,0,0,0-.3-.637v-.7h.316A1.353,1.353,0,0,0,15.275,3.6a.37.37,0,0,0-.369-.369H13.653l-.208-1.511A1.991,1.991,0,0,0,11.085.039a6.733,6.733,0,0,1-2.629,0A1.991,1.991,0,0,0,6.1,1.721L5.887,3.232H4.635a.37.37,0,0,0-.369.369A1.353,1.353,0,0,0,5.617,4.953h.316v.7a.819.819,0,0,0-.3.637V6.6a.824.824,0,0,0,.79.822A3.131,3.131,0,0,0,7.475,9.491a3.873,3.873,0,0,0,.446.331v.441a.622.622,0,0,1-.087.3l-.69.117a.5.5,0,0,0-.489-.2l-.726.126a.5.5,0,0,0-.395.356l-.515.089a3.112,3.112,0,0,0-2.265,3v2.894a.862.862,0,0,0,.861.861H15.925a.862.862,0,0,0,.861-.861V14.048a3.093,3.093,0,0,0-.621-1.866Zm-2.612,2.311a1.914,1.914,0,0,0,.447.872,1.37,1.37,0,0,1,.36.926v.99H5.181v-.99a1.37,1.37,0,0,1,.36-.926,1.872,1.872,0,0,0,.45-.864.246.246,0,0,1,.239-.189h7.091a.237.237,0,0,1,.232.181Zm-6.314-.7V11.845l.3.452a1.4,1.4,0,0,0,1.17.63,5.257,5.257,0,0,0,1.064-.216,5.268,5.268,0,0,0,1.064.216A1.4,1.4,0,0,0,12,12.3l.3-.452v1.945Zm4.329-1.779a.878.878,0,0,1-.936.371l-.325-.078,1.329-1.224.489.083Zm1.518-6.46a1.5,1.5,0,0,0-.43.144V4.953h.43ZM4.8,3.754H6.939a.261.261,0,0,0,0-.522H6.414l.2-1.44A1.47,1.47,0,0,1,8.355.55a7.255,7.255,0,0,0,2.831,0,1.47,1.47,0,0,1,1.743,1.242l.2,1.44H8.155a.261.261,0,1,0,0,.522h6.584a.831.831,0,0,1-.816.678H5.617A.831.831,0,0,1,4.8,3.754Zm2.084,1.2V5.7a1.5,1.5,0,0,0-.43-.144v-.6Zm.041,2.2A.261.261,0,0,0,6.666,6.9H6.453a.3.3,0,0,1-.3-.3V6.286a.3.3,0,0,1,.114-.234.878.878,0,0,1,.525.212.362.362,0,0,0,.616-.258V4.953h4.727V6.006a.362.362,0,0,0,.616.258.879.879,0,0,1,.525-.212.3.3,0,0,1,.114.235V6.6a.3.3,0,0,1-.3.3h-.213a.261.261,0,0,0-.261.255A2.629,2.629,0,0,1,11.725,9.1a2.922,2.922,0,0,1-3.91,0,2.628,2.628,0,0,1-.889-1.942ZM11.1,10.1v.166a1.122,1.122,0,0,0,.12.494L9.77,12.089,8.323,10.757a1.122,1.122,0,0,0,.12-.494V10.1a3.384,3.384,0,0,0,2.655,0ZM7.9,11.081,9.234,12.3c-.1,0-.837.355-1.262-.293l-.557-.848ZM6.718,11v2.791H6.23a.781.781,0,0,0-.193.024v-2.7ZM3.277,16.943V14.048a2.594,2.594,0,0,1,1.848-2.485l.392-.068v2.782a.773.773,0,0,0-.034.109,1.357,1.357,0,0,1-.326.626,1.89,1.89,0,0,0-.5,1.278v.99H3.616a.339.339,0,0,1-.339-.339Zm12.987,0a.339.339,0,0,1-.339.339H14.881v-.99a1.89,1.89,0,0,0-.5-1.278,1.373,1.373,0,0,1-.323-.635.732.732,0,0,0-.037-.117v-.986a.261.261,0,1,0-.522,0v.538a.753.753,0,0,0-.182-.023h-.5V11l.68.118v.942a.261.261,0,1,0,.522,0V11.5l.392.068a2.594,2.594,0,0,1,1.848,2.485Z",
    transform: "translate(-2.755 0)",
    fill: "#101944"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveFarmer);
export default __webpack_public_path__ + "static/media/InactiveFarmer.a996d74805d242ace40d479b896caa88.svg";
export { ForwardRef as ReactComponent };